import modal from '@/js/utils/modal';
const blockTitleTile = () => {
  if ($('.block-title-and-tile').length === 0) return;
  const modalEl = modal('title-tile-modal');
  $('.title-tile-modal .tingle-modal__close')
    .detach()
    .prependTo('.title-tile-modal .tingle-modal-box');

  $('.js-popup-tile-link').on('click', (e) => {
    const currentTargetDataTrigger = e.currentTarget?.dataset?.trigger || '';
    if (currentTargetDataTrigger) {
      modalEl.setContent(
        document.querySelector(`[data-content="${currentTargetDataTrigger}"]`)
          .innerHTML
      );
      modalEl.open();
    }
  });
};

export default blockTitleTile;
